var MutualFundOrderBookPresenter = /** @class */ (function () {
    function MutualFundOrderBookPresenter(usecase, actions) {
        this.usecase = usecase;
        this.actions = actions;
    }
    MutualFundOrderBookPresenter.prototype.getMFOrderbookSummary = function (req) {
        var _this = this;
        this.actions.orderbookSummaryTransaction.startMutualFundSIP_STP_SWP_TransactionsTableShimmer();
        this.actions.orderbookSummaryTransaction.hideError();
        this.usecase.getMFOrderbookSummary.execute({
            onSuccess: function (data) {
                _this.actions.orderbookSummaryTransaction.getMutualFundSummaryTransactions(data);
                _this.actions.orderbookSummaryTransaction.stopMutualFundSIP_STP_SWP_TransactionsTableShimmer();
            },
            onError: function (error) {
                _this.actions.orderbookSummaryTransaction.stopMutualFundSIP_STP_SWP_TransactionsTableShimmer();
                _this.actions.orderbookSummaryTransaction.setError({
                    error: error,
                    isOpen: true,
                });
            },
        }, req);
    };
    MutualFundOrderBookPresenter.prototype.getMutualFundOrderBook = function (req) {
        var _this = this;
        this.actions.orderbookAllTransactions.startMutualFundAllTransactionsTableShimmer();
        this.actions.orderbookAllTransactions.hideError();
        this.usecase.getMutualFundOrderBook.execute({
            onSuccess: function (data) {
                _this.actions.orderbookAllTransactions.getMutualFundAllTransactions(data);
                _this.actions.orderbookAllTransactions.stopMutualFundAllTransactionsTableShimmer();
            },
            onError: function (error) {
                _this.actions.orderbookAllTransactions.stopMutualFundAllTransactionsTableShimmer();
                _this.actions.orderbookAllTransactions.setError({
                    error: error,
                    isOpen: true,
                });
            },
        }, req);
    };
    MutualFundOrderBookPresenter.prototype.downloadMFOrderBookExcelFile = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.downloadMFOrderBookExcelFile.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    MutualFundOrderBookPresenter.prototype.getMFOrderBookPastInstallments = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getMFOrderBookPastInstallments.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    MutualFundOrderBookPresenter.prototype.getMFOrderbookTimeline = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getMFOrderbookTimeline.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    MutualFundOrderBookPresenter.prototype.sendConsentApprovalLink = function (request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.sendConsentApprovalLink.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, request);
        });
    };
    MutualFundOrderBookPresenter.prototype.resendPaymentLink = function (request) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.resendPaymentLink.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, request);
        });
    };
    MutualFundOrderBookPresenter.prototype.updateCurrentSelectedTransactionTab = function (data) {
        this.actions.orderbookMutualFundTransactionsCommon.updateCurrentActiveTransactionsTab(data);
    };
    MutualFundOrderBookPresenter.prototype.updateAllTransactionsFilters = function (data) {
        this.actions.orderbookAllTransactions.updateAppliedFilters(data);
    };
    MutualFundOrderBookPresenter.prototype.clearAllTransactionsFilters = function () {
        this.actions.orderbookAllTransactions.clearAllFilters();
    };
    MutualFundOrderBookPresenter.prototype.updateSIP_STP_SWP_Filters = function (data) {
        this.actions.orderbookSummaryTransaction.updateAppliedFilters(data);
    };
    MutualFundOrderBookPresenter.prototype.clearSIP_STP_SWP_Filters = function () {
        this.actions.orderbookSummaryTransaction.clearAllFilters();
    };
    MutualFundOrderBookPresenter.prototype.getMFOrderbookTransactionType = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getMFOrderbookTransactionType.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, null);
        });
    };
    MutualFundOrderBookPresenter.prototype.updateInitialMandateData = function (data) {
        this.actions.mandateTransaction.updateInitialData(data);
    };
    MutualFundOrderBookPresenter.prototype.updateAndApplyMandateFilters = function (data) {
        this.actions.mandateTransaction.updateAppliedFilters(data);
    };
    MutualFundOrderBookPresenter.prototype.clearMandateFilters = function () {
        this.actions.mandateTransaction.clearAllFilters();
    };
    MutualFundOrderBookPresenter.prototype.resetMandateFiltersAndSearch = function () {
        this.actions.mandateTransaction.resetMandateFiltersAndSearch();
    };
    MutualFundOrderBookPresenter.prototype.getAllClientsOfRMF = function (req) {
        var _this = this;
        this.actions.orderbookMutualFundTransactionsCommon.startGetAllClientOfRMLoader();
        this.actions.orderbookMutualFundTransactionsCommon.hideErrorForAllClientsOfRM();
        this.usecase.getAllClientsOfRM.execute({
            onSuccess: function (data) {
                _this.actions.orderbookMutualFundTransactionsCommon.getAllClientsOfRM(data);
                _this.actions.orderbookMutualFundTransactionsCommon.stopGetAllClientOfRMLoader();
            },
            onError: function (error) {
                _this.actions.orderbookMutualFundTransactionsCommon.stopGetAllClientOfRMLoader();
                _this.actions.orderbookMutualFundTransactionsCommon.setErrorForAllClientsOfRM({
                    error: error,
                    isOpen: true,
                });
            },
        }, req);
    };
    MutualFundOrderBookPresenter.prototype.getMFOrderBookCtaDetail = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.getMFOrderBookCtaDetail.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    MutualFundOrderBookPresenter.prototype.resetAllTransactionsFiltersAndSearch = function () {
        this.actions.orderbookAllTransactions.resetAllTransactionsFiltersAndSearch();
    };
    MutualFundOrderBookPresenter.prototype.resetSIP_STP_SWP_TransactionsFiltersAndSearch = function () {
        this.actions.orderbookSummaryTransaction.resetSIP_STP_SWP_TransactionsFiltersAndSearch();
    };
    MutualFundOrderBookPresenter.prototype.getTransferInTabData = function (req) {
        var _this = this;
        this.actions.orderbookTransferIn.startMutualFundTransferInTableShimmer();
        this.actions.orderbookTransferIn.hideError();
        this.usecase.getTransferInTabData.execute({
            onSuccess: function (data) {
                _this.actions.orderbookTransferIn.getOrderbookTransferIn(data);
                _this.actions.orderbookTransferIn.stopMutualFundTransferInTableShimmer();
            },
            onError: function (error) {
                _this.actions.orderbookTransferIn.stopMutualFundTransferInTableShimmer();
                _this.actions.orderbookTransferIn.setError({
                    error: error,
                    isOpen: true,
                });
            },
        }, req);
    };
    MutualFundOrderBookPresenter.prototype.updateTransferInFilters = function (request) {
        this.actions.orderbookTransferIn.updateAppliedFilters(request);
    };
    return MutualFundOrderBookPresenter;
}());
export default MutualFundOrderBookPresenter;
